import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-plus-circle',
  templateUrl: './icon-plus-circle.component.html',
  styleUrls: ['./icon-plus-circle.component.scss']
})
export class IconPlusCircleComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
